export const createRequestBody = (values) => {
  let requestParams = {};

  requestParams["page"] = values && values.page ? values.page : 1;
  requestParams["pageSize"] = values && values.pageSize ? values.pageSize : 10;
  requestParams["domainCode"] =
    values.issuerNumber &&
    values.issuerNumber.domainCode &&
    values.issuerNumber.domainCode;

  requestParams["actor"] =
    values.issuerNumber &&
    values.issuerNumber.email &&
    values.issuerNumber.email;

  requestParams["fromDate"] =
    values.startDate &&
    `${values.startDate.getFullYear()}-${(
      "0" +
      (values.startDate.getMonth() + 1)
    ).slice(-2)}-${("0" + values.startDate.getDate()).slice(-2)}`;

  requestParams["toDate"] =
    values.endDate &&
    `${values.endDate.getFullYear()}-${(
      "0" +
      (values.endDate.getMonth() + 1)
    ).slice(-2)}-${("0" + values.endDate.getDate()).slice(-2)}`;

  requestParams["groupId"] = values && values.groupId && values.groupId.id;
  if (values.download) {
    requestParams["isDownload"] = true;
    requestParams["fileType"] = values && values.fileType;
    return requestParams;
  }

  return requestParams;
};
